// eslint-disable-next-line no-unused-vars
import i18n from '@/libs/i18n'
import { hasPrePreviewAccess } from '@/utils/prePreviewAccess'

// Simple approach: only export navigation if user has access
export default hasPrePreviewAccess() ? [
  {
    id: 'nav-pre-preview',
    title: 'Pre-Preview',
    icon: 'EyeIcon',
    route: 'pre-preview',
    tooltip: 'Pre-Preview Creative Management',
    children: [
      {
        id: 'nav-pre-preview-upload',
        title: 'Upload Creative',
        route: 'pre-preview-upload',
      },
      {
        id: 'nav-pre-preview-creatives',
        title: 'Creative Library',
        route: 'pre-preview-creatives',
      },
      {
        id: 'nav-pre-preview-tasks',
        title: 'Task Log',
        route: 'pre-preview-tasks',
      },
    ],
  },
] : []
